import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useWorkspace } from '../../contexts/WorkspaceContext';

const AccessDenied = () => {
  const location = useLocation();
  const { workspaceName, workspaceId } = useWorkspace();
  const fromPath = location.state?.from || '/';

  return (
    <div className="access-denied-page">
      <div className="access-denied-card">
        <i className="fas fa-lock access-denied-icon" />
        <h2>Access Denied</h2>
        <p>
          You do not have permission to view this page.
          {workspaceId ? ` This workspace is ${workspaceName || workspaceId}.` : ''}
        </p>
        <div className="access-denied-actions">
          <Link className="button button-secondary" to={fromPath}>
            Go back
          </Link>
          <Link className="button button-primary" to="/">
            Go to dashboard
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
